// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__2CVBY","colCheckbox":"styles_colCheckbox__1TgKl"};